import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myDocumentsIsDocument = atom({
  key: "myDocumentsIsDocument",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
